module.exports = __webpack_public_path__ + "img/five-cover.59ce909f.png";